import PropTypes from 'prop-types';
import PayoutImpl from './payout-info.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Component to display payout info of bet funds.
 *
 * @class PayoutInfo
 * @memberof Mojito.Presentation.Components.BetFunds
 */

/**
 * PayoutInfo props.
 *
 * @property {number} [payout] - Payout value.
 * @property {number} [previousPayout] - Previous payout value.
 * @property {string} labelKey - Translation key for label.
 * @property {string} [currencyCode] - Currency.
 * @property {boolean} [showIcon] - Flag to display icon.
 * @property {string} [class] - Class name assigned to the root element.
 * @property {string} [testId] - Testing identifier rendered as data-testid on the root element.
 *
 * @memberof Mojito.Presentation.Components.BetFunds.PayoutInfo
 */
const propTypes = {
    payout: PropTypes.number,
    previousPayout: PropTypes.number,
    labelKey: PropTypes.string.isRequired,
    currencyCode: PropTypes.string,
    showIcon: PropTypes.bool,
    class: PropTypes.string,
    testId: PropTypes.string,
};

export default UIView('PayoutInfo', PayoutImpl, propTypes);
